export default {
	"火蚁联盟": "Liên Minh FireAnt",
	"娱乐经济的能量核心": "Lõi năng lượng của nền kinh tế giải trí",
	"节点订阅系统": "Hệ thống đăng ký Node",
	"首页": "Trang chủ",
	"推荐人：": "Người giới thiệu:",
	"我的邀请链接（点击复制）": "Link mời của tôi (Nhấn để sao chép)",
	"初级节点": "Node cơ bản",
	"高级节点": "Node nâng cao",
	"NFT卡牌": "Thẻ NFT",
	"獲得全網NFT新增業績2.5%分紅": "Nhận 2.5% hoa hồng từ tổng doanh số NFT toàn mạng",
	"获得4倍代币燃料值": "Nhận giá trị nhiên liệu token gấp 4 lần",
	"获得5倍代币燃料值": "Nhận giá trị nhiên liệu token gấp 5 lần",
	"获得娱乐游戏平台收益的5%分红": "Nhận 5% lợi nhuận từ nền tảng giải trí",
	"获得每日产出FAC代币2%分配": "Nhận 2% FAC token mỗi ngày",
	"请连接钱包": "Vui lòng kết nối ví",
	"USDT余额不足": "Số dư USDT không đủ",
	"转账已发起": "Giao dịch đã được khởi tạo",
	"转账被取消": "Giao dịch bị hủy",
	"取消": "Hủy",
	"未连接钱包": "Chưa kết nối ví",
	"复制成功": "Sao chép thành công",
	"订单记录": "Lịch sử đơn hàng",
	"我的社群": "Cộng đồng của tôi",
	"节点预售": "Bán trước Node",
	"我的订单": "Đơn hàng của tôi",
	"创建时间：": "Thời gian tạo:",
	"转账哈希：": "Tx Hash:",
	"购买初级节点": "Mua Node cơ bản",
	"购买高级节点": "Mua Node nâng cao",
	"空": "Trống",
	"獲得算力挖礦": "Nhận quyền đào theo hashpower",
	"已购买": "Đã mua",
	"獲得DAO投票權限": "Nhận quyền biểu quyết DAO",
	"付款地址：": "Địa chỉ thanh toán:",
	"節點類型：": "Loại Node:",
	"获取中": "Đang lấy dữ liệu",
	"交易中": "Đang xử lý",
	"金额：": "Số tiền:",
	"推荐地址：": "Địa chỉ giới thiệu:",
	"推荐时间：": "Thời gian giới thiệu:",
	"社群总业绩 U：": "Tổng doanh số cộng đồng (U):",
	"社群总地址 个：": "Tổng số ví cộng đồng:",
	"确认绑定?": "Xác nhận liên kết?",
	"确定": "Xác nhận",
	"操作成功": "Thành công",
	"操作失败": "Thất bại",
	"获取数据失败": "Không lấy được dữ liệu",
	"授权成功": "Cấp quyền thành công",
	"授权失败": "Cấp quyền thất bại",
	"操作中": "Đang xử lý",
	"进入共振": "Tham gia cộng hưởng",
	"赎回": "Rút lại",
	"领取奖励": "Nhận thưởng",
	"开始共振": "Bắt đầu cộng hưởng",
	"共振中，距离共振结束还有": "Đang cộng hưởng, còn lại:",
	"NFT已经失效": "NFT đã hết hạn",
	"超时，NFT即将失效": "Sắp hết hạn NFT",
	"共振未开始": "Cộng hưởng chưa bắt đầu",
	"赎回共振金": "Rút quỹ cộng hưởng",
	"共振结束": "Kết thúc cộng hưởng",
	"详情": "Chi tiết",
	"次数：": "Số lần:",
	"算力：": "Hashpower:",
	"燃料：": "Nhiên liệu:",
	"剩余用能量：": "Năng lượng còn lại:",
	"总能量：": "Tổng năng lượng:",
	"类型：": "Loại:",
	"参与共振流动性": "Tham gia thanh khoản cộng hưởng",
	"加载中": "Đang tải",
	"未开始": "Chưa bắt đầu",
	"共振中": "Đang cộng hưởng",
	"异常": "Bất thường",
	"USD资产": "Tài sản USD",
	"FAC资产": "Tài sản FAC",
	"NFT卡牌：": "Thẻ NFT:",
	"共振金：": "Tiền đặt cộng hưởng:",
	"总收益：": "Tổng lợi nhuận:",
	"共振奖励：": "Thưởng cộng hưởng:",
	"直推奖励：": "Thưởng giới thiệu trực tiếp:",
	"层级奖励：": "Thưởng cấp độ:",
	"社区奖励：": "Thưởng cộng đồng:",
	"节点分红：": "Cổ tức Node:",
	"已领取：": "Đã nhận:",
	"我的算力：": "Hashpower của tôi:",
	"我的燃料：": "Nhiên liệu của tôi:",
	"我的矿池：": "Pool của tôi:",
	"已释放FAC：": "FAC đã giải phóng:",
	"社区奖励FAC：": "Thưởng FAC cộng đồng:",
	"节点分红FAC：": "FAC cổ tức Node:",
	"平台分红FAC：": "FAC cổ tức nền tảng:",
	"可领取FAC：": "FAC có thể nhận:",
	"已领取FAC：": "FAC đã nhận:",
	"领取": "Nhận",
	"没有可提取的FAC": "Không có FAC để rút",
	"没有可用的能量": "Không có năng lượng khả dụng",
	"参数获取失败": "Lỗi lấy thông số",
	"领取成功": "Nhận thành công",
	"共振奖励提取成功": "Đã rút thưởng cộng hưởng",
	"共振奖励提取失败": "Rút thưởng cộng hưởng thất bại",
	"层级奖励提取成功": "Rút thưởng cấp độ thành công",
	"NFT价格": "Giá NFT",
	"数量": "Số lượng",
	"总价": "Tổng giá",
	"账户余额": "Số dư tài khoản",
	"购买NFT": "Mua NFT",
	"推荐地址": "Địa chỉ giới thiệu",
	"我的邀请链接": "Link mời của tôi",
	"复制邀请链接": "Sao chép link mời",
	"购买失败": "Mua thất bại",
	"购买成功": "Mua thành công",
	"我的资产": "Tài sản của tôi",
	"节点认购": "Đăng ký mua nút",
	"时": "giờ",
	"分": "phút",
	"秒": "giây",
	"可领取：": "Có thể nhận:",
	"我的能量：": "Năng lượng của tôi:",
	"提取": "Trích xuất",
	"推荐钱包：": "Ví được khuyến nghị:",
	"确认绑定？": "Xác nhận liên kết?",
	"火蚁联盟将于{time}后启动。": "Liên minh Kiến Lửa sẽ khởi động sau {time}.",
	"本操作将在24小时公测期后开放": "Thao tác này sẽ được mở sau thời gian thử nghiệm công khai 24 giờ",
	"暂未开放": "Chưa mở",
	"请使用分享链接打开。": "Vui lòng mở bằng liên kết chia sẻ.",
	"Fire Ant Alliance邀请您参与我们的多签。": "Fire Ant Alliance mời bạn tham gia chữ ký đa phương của chúng tôi.",
	"操作过于频繁": "Thao tác quá thường xuyên",
	"社区奖励提取成功": "Rút phần thưởng cộng đồng thành công",
	"已释放节点分红FAC：": "Cổ tức Nút FAC Đã Phát Hành:",
	"社群节点总地址 个：": "Tổng địa chỉ nút cộng đồng cái：",
	"社群NFT总地址 个：": "Tổng địa chỉ NFT cộng đồng cái：",
	"NFT业绩 U：": "Hiệu suất NFT",
	"节点分红释放FAC：": "Cổ tức nút đã phát hành FAC:",
	"矿池释放FAC：": "Pool khai thác đã phát hành FAC:",
	"无剩余能量": "Không còn năng lượng",
}
